module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq215-f8056ea4edef06c753f7b336e777b8d8.jpg";